var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#FFFFF",
    stroke: "#FFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "ic_fluent_multiselect_24_filled"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD0D-Product-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_multiselect_24_filled",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65066382,15.2406341 C9.03778956,15.5723434 9.1090367,16.1357649 8.83506726,16.550341 L8.75936591,16.6506638 L5.75936591,20.1518539 C5.44270399,20.5214185 4.91140117,20.6054403 4.49988533,20.3672446 L4.39969546,20.3009616 L2.39969546,18.7997715 C1.95799386,18.4682325 1.86868945,17.8413971 2.20022849,17.3996955 C2.50626453,16.9919709 3.06391403,16.8845138 3.49530567,17.1311589 L3.60030454,17.2002285 L4.85,18.138 L7.24063409,15.3493362 C7.59998579,14.92995 8.23127761,14.8812824 8.65066382,15.2406341 Z M21,17 C21.5522847,17 22,17.4477153 22,18 C22,18.5128358 21.6139598,18.9355072 21.1166211,18.9932723 L21,19 L11,19 C10.4477153,19 10,18.5522847 10,18 C10,17.4871642 10.3860402,17.0644928 10.8833789,17.0067277 L11,17 L21,17 Z M20.9875789,11 C21.5398637,11 21.9875789,11.4477153 21.9875789,12 C21.9875789,12.5128358 21.6015387,12.9355072 21.1042001,12.9932723 L20.9875789,13 L10.9875789,13 C10.4352942,13 9.98757893,12.5522847 9.98757893,12 C9.98757893,11.4871642 10.3736191,11.0644928 10.8709578,11.0067277 L10.9875789,11 L20.9875789,11 Z M8.65066382,3.24063409 C9.03778956,3.57234335 9.1090367,4.1357649 8.83506726,4.55034098 L8.75936591,4.65066382 L5.75936591,8.15185393 C5.44270399,8.52141847 4.91140117,8.60544033 4.49988533,8.36724463 L4.39969546,8.30096162 L2.39969546,6.79977151 C1.95799386,6.46823246 1.86868945,5.84139707 2.20022849,5.39969546 C2.50626453,4.9919709 3.06391403,4.88451378 3.49530567,5.13115892 L3.60030454,5.20022849 L4.85,6.138 L7.24063409,3.34933618 C7.59998579,2.92994996 8.23127761,2.88128238 8.65066382,3.24063409 Z M21,5 C21.5522847,5 22,5.44771525 22,6 C22,6.51283584 21.6139598,6.93550716 21.1166211,6.99327227 L21,7 L11,7 C10.4477153,7 10,6.55228475 10,6 C10,5.48716416 10.3860402,5.06449284 10.8833789,5.00672773 L11,5 L21,5 Z",
    id: "\\uD83C\\uDFA8-Color"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleOptions);
export default __webpack_public_path__ + "static/media/multipleOptions.fdbf8d43f0e580309cfd67d4dd51c87a.svg";
export { ForwardRef as ReactComponent };